import {Component, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {NavController, NavParams, Searchbar, Content, ViewController} from 'ionic-angular';

import 'rxjs/add/operator/debounceTime';

import {CONFIG} from '../../../app/config';

import {LogadoService} from '../../../providers/logado-service';
import {TGoogleAnalytic, TModalClick, TStatusBar, Util} from "../../../app/util";
import {TFollowup, TCentralLido, TImageModel, TProfileTeam} from "../../../app/enum";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'page-listing-menu',
    templateUrl: 'listing-menu.html',
    providers: []
})

export class ListingMenuPage {

    @ViewChild(Content) content: Content;
    @ViewChild('searchbar') searchbar: Searchbar;

    TFollowup: any = TFollowup;
    TCentralLido: any = TCentralLido;
    TImageModel: any = TImageModel;

    config: any;
    logado: any;
    profile: any;

    pagecut: boolean;
    tabmenu: boolean;
    forward: boolean;
    hotspot: any;
    modalshow: any;

    showBusca: boolean = false;
    finded: Array<any> = [];
    amigos: Array<any> = [];

    loaded: boolean = false;
    limitQtde: number = 0;
    limitCount: number = 0;
    limitPage: number = 0;

    searchTipo: 'zero' | 'like' = null;
    searchTerm: string = '';
    searchControl: FormControl = new FormControl();
    searching: boolean;


    constructor(public navCtrl: NavController, public navParams: NavParams,
                public sanitizer: DomSanitizer,
                public logadoService: LogadoService,
                public viewCtrl: ViewController, public util: Util) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.profile = this.navParams.get('profile');

        this.pagecut = this.navParams.get('pagecut');
        this.tabmenu = (typeof this.navParams.get('tabmenu') == 'undefined') ? true : this.navParams.get('tabmenu');
        this.forward = false;
        this.hotspot = this.navParams.get('hotspot');
        this.modalshow = this.navParams.get('modalshow');

        /* Google Analytics */
        //this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Listing', '/listing-menu/' + this.modalshow.window.toLowerCase());

        this.centralLoad();

    }

    ionViewDidEnter() {

        if (!this.pagecut) this.util.statusBarColor((this.modalshow.corcor == 'CorMilk') ? TStatusBar.sbStyleDefault : TStatusBar.sbStyleLightContent, false);
        if (this.modalshow.opened) this.toggleBusca(true);

    }

    ionViewDidLoad() {

        this.searchControl.valueChanges.debounceTime(700)
            .subscribe(search => {

                this.searching = false;
                this.finded = this.filterArrays(this.searchTipo);

            });

    }

    centralView() {

        return (this.modalshow.window == 'Develop' || this.modalshow.window == 'Notifica');

    }

    //teste-test-teste - infinite-scroll //#APP-PUBLISH //todo: eventMais procure por isso!!!
    centralLoad(eventMais?: any) {

        /* Google Analytics */
        if (!this.limitPage) this.util.googleAnalytic(TGoogleAnalytic.gaPageview, this.modalshow.window, '/listing-menu/' + this.modalshow.window.toLowerCase());

        this.modalshow.onShow(this.modalshow, this, this.limitPage, null, eventMais);

    }

    toggleBusca(forceshow?) {

        this.showBusca = (forceshow ? true : !this.showBusca);
        this.content.resize();

        if (this.showBusca) {
            setTimeout(() => this.searchbar.setFocus(), 500);
        }

    }

    buttonClick(line?) {

        if (this.modalshow.button.value) {

            let buttons: Array<any> = [];

            this.modalshow.button.value.map(data => {

                let show = () => this.modalshow.onShow(this.modalshow, this, this.limitPage, data.title);
                let okuy = () => this.modalshow.onOkuy(this.modalshow, this, line, TModalClick.mcMore, null);
                buttons.push({text: data.title, handler: () => (line ? okuy() : show())});

            });

            /** OPEN **/
            this.util.sheetOpen(buttons, this.modalshow.button.title);

        }

    }

    iconimg(tipo?) {

        let icon = (this.modalshow.imagem && this.modalshow.imagem.slice(0, 6) == 'b-icon');
        return (tipo == 'icon' && icon) || (tipo != 'icon' && !icon);

    }

    processWindow(data, addself: boolean = false) {

        // joga user logado em primeiro
        if (addself) {
            let line: any = {};
            line.ProfileID = this.logado.Profile.ProfileID;
            line.ProfileShow = this.logado.Profile.ProfileShow;
            line.ProfileFace = this.logado.Profile.ProfileFace;
            data.unshift(line);
        }

        data.map( line => {

            if (this.modalshow.arrayz) {
                /*
                let lino = line[this.modalshow.arrayz][0];
                line[this.modalshow.alignL.show] = lino[this.modalshow.alignL.show];
                line[this.modalshow.alignL.info] = lino[this.modalshow.alignL.info];
                for (let field of (this.modalshow.alignL.code || [])) line[field] = (lino[field] ? lino[field] : line[field]);
                for (let field of (this.modalshow.alignL.find || [])) line[field] = (lino[field] ? lino[field] : line[field]);

                line[this.modalshow.alignC.show] = lino[this.modalshow.alignC.show];
                line[this.modalshow.alignC.info] = lino[this.modalshow.alignC.info];
                for (let field of (this.modalshow.alignC.code || [])) line[field] = (lino[field] ? lino[field] : line[field]);
                for (let field of (this.modalshow.alignC.find || [])) line[field] = (lino[field] ? lino[field] : line[field]);

                line[this.modalshow.alignR.show] = lino[this.modalshow.alignR.show];
                line[this.modalshow.alignR.info] = lino[this.modalshow.alignR.info];
                for (let field of (this.modalshow.alignR.code || [])) line[field] = (lino[field] ? lino[field] : line[field]);
                for (let field of (this.modalshow.alignR.find || [])) line[field] = (lino[field] ? lino[field] : line[field]);
                */
            }

        });

    }

    deleteLine(line) {

        let itemIndex;

        //Delete Item Source
        itemIndex = this.amigos.indexOf(line);
        this.amigos.splice(itemIndex, 1);

        //Delete Item Sender
        itemIndex = this.finded.indexOf(line);
        this.finded.splice(itemIndex, 1);

    }

    insertLine(line) {

        this.amigos.splice(0, 0, line);
        this.finded.splice(0, 0, line);

    }

    parseArray(data?: any, eventMais?: any, limitQtde: number = 0, limitPage: number = 0, addself: boolean = false, arrayz: any = null, tipo : 'zero' | 'like' = 'like') {
        
        //#GAMBIARRA - ARRUMAR TODO .TS FIND INTEIRO
        if (this.searchTipo == null) this.searchTipo = tipo;

        this.modalshow.arrayz = arrayz;

        if (!data) {
            this.util.alertSimply('Keyname Undefined!', 'Developer Error');
            return;
        }

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Modal Show - ' + this.modalshow.header, '/modal-action/' + this.modalshow.header);

        this.limitCount = data.length;
        this.limitQtde = limitQtde;
        this.limitPage = limitPage;
        if (eventMais) eventMais.complete();

        this.processWindow(data, addself);

        if (!limitPage) this.amigos = data;
        if (limitPage) Array.prototype.push.apply(this.amigos, data);

        this.finded = this.filterArrays(this.searchTipo);
        this.loaded = true;

    }

    searchStart(isEnter = false) {

        this.searching = true;

    }

    filterSearch(bool, termns, aligns, nameds, lino, tipo : 'zero' | 'like' = 'like'): boolean {

        termns.forEach(termn => {

            aligns.forEach(alignX => {

                nameds.forEach(named => {

                    let find = this.modalshow[alignX][named];
                    let log = '';
                    for (let field in find) {
                        log = log + ' - ' + lino[find[field]];
                        let item = (lino[find[field]] || '');

                        let string = this.util.removerAcentos(item.toString().toLowerCase());
                        if (named == 'find' && tipo == 'zero' && string.indexOf(termn) == 0) bool = true;
                        if (named == 'find' && tipo == 'like' && string.indexOf(termn) >= 0) bool = true;
                        if (named == 'code' && string == termn) bool = true;
                    }

                });

            });

        });

        return bool;

    }

    filterArrays(tipo : 'zero' | 'like' = 'like') {
        
        if (this.searchTerm == '') return this.util.deepCopy(this.amigos);

        //let array = (this.modalshow.arrayz ? line[this.modalshow.arrayz] : [line]);

        //Prepare        
        let termns = tipo == 'zero' ? [this.searchTerm.toLowerCase()] : this.searchTerm.toLowerCase().split(' ');
        let aligns = ['alignL', 'alignC', 'alignR'];
        let nameds = ['code', 'find'];

        aligns.forEach(alignX => {
            let show = this.modalshow[alignX].show;
            if (!this.modalshow[alignX].find) this.modalshow[alignX].find = [];
            if (this.modalshow[alignX].find.indexOf(show) == -1) this.modalshow[alignX].find.push(show);
            //console.log(alignX, JSON.stringify(this.modalshow[alignX].find));
        });

        //Exato: Bittencourt Gabriel (acha resultado)
        let result: any[] = [];
        result = this.amigos.filter((line) => {

            line.finded = true;
            let bool = false;


            if (line.BrandedSpots) {
                line.BrandedSpots.forEach(hotspot => {
                    hotspot.Unidades.forEach(lino => bool = this.filterSearch(bool, termns, aligns, nameds, lino, tipo));
                });
            }
            else {
                bool = this.filterSearch(bool, termns, aligns, nameds, line, tipo);
            }

            if (!bool) line.finded = false;
            return line.finded;

        });


        //Other: Caio Bittencourt (acha parecido)
/*
        let other: any[] = [];
        other = this.amigos.filter((line) => {
            if (line.finded) return false;

            let bool = false;
            line.BrandedSpots.forEach(hotspot => {

                hotspot.Unidades.forEach(lino => {

                    termns.forEach(termn => {

                        aligns.forEach(alignX => {

                            nameds.forEach(named => {

                                let find = this.modalshow[alignX][named];
                                let log = '';
                                for (let field in find) {
                                    log = log + ' - ' + lino[find[field]];
                                    let item = (lino[find[field]] || '');

                                    let string = this.util.removerAcentos(item.toString().toLowerCase());
                                    if (named == 'like' && string.indexOf(termn) >= 0) bool = true;
                                    if (named == 'code' && string == termn) bool = true;
                                }

                            });

                        });

                    });

                });

            });

            if (!bool) line.finded = false;
            return line.finded;

        });


        //Other Process (adiciona no final)
        other.forEach( line => result.push(line));

        console.log(result);
*/
        return result;

/*
        //Prepare
        let terms = this.searchTerm.toLowerCase().split(' ');
        let aligns = ['alignL', 'alignC', 'alignR'];
        let nameds = ['code', 'like'];


        aligns.forEach(alignX => {
            let show = this.modalshow[alignX].show;
            if (!this.modalshow[alignX].find) this.modalshow[alignX].find = [];
            if (this.modalshow[alignX].find.indexOf(show) == -1) this.modalshow[alignX].find.push(show);
            //console.log(alignX, JSON.stringify(this.modalshow[alignX].find));
        });


        //Exato: Bittencourt Gabriel (acha resultado)
        let result: any[] = [];
        result = this.amigos.filter((line) => {

            line.finded = true;

            let array = (this.modalshow.arrayz ? line[this.modalshow.arrayz] : [line]);
            array.forEach(lino => {

                terms.forEach(term => {

                    if (term) {

                        let show = this.util.removerAcentos((lino[this.modalshow.alignC.show] || '').toLowerCase());

                        let bool = false;
                        aligns.forEach(alignX => {
                            nameds.forEach(named => {
                                //this.modalshow[alignX][named]


                                let find = this.modalshow[alignX][named];

                                let log = '';
                                for (let field in find) {
                                    log = log + ' - ' + lino[find[field]];
                                    let item = (lino[find[field]] || '');
                                    if (named == 'like' && item.toString().toLowerCase().indexOf(term) >= 0) bool = true;
                                    if (named == 'code' && item.toString().toLowerCase() == term) bool = true;
                                }

                            });
                        });

                        //if (!bool && show.indexOf(term) == -1) line.finded = false;
                        if (!bool) line.finded = false;

                    }

                });

            });

            //for (let index in terms) {
            //}

            return line.finded;

        });


        //Other: Caio Bittencourt (acha parecido)
        let other: any[] = [];
        other = this.amigos.filter((line) => {
            if (line.finded) return false;

            let array = (this.modalshow.arrayz ? line[this.modalshow.arrayz] : [line]);
            array.forEach(lino => {

                terms.forEach(term => {

                    if (term) {

                        let show = this.util.removerAcentos((line[this.modalshow.alignC.show] || '').toLowerCase());

                        let bool = false;
                        aligns.forEach(alignX => {
                            nameds.forEach(named => {
                                let find = this.modalshow[alignX][named];
                                let log = '';
                                for (let field in find) {
                                    log = log + ' - ' + line[find[field]];
                                    let item = (line[find[field]] || '');
                                    if (named == 'like' && item.toString().indexOf(term) >= 0) bool = true;
                                    if (named == 'code' && item.toString() == term) bool = true;
                                }
                            });
                        });

                        if (bool || show.indexOf(term) >= 0) line.finded = true;

                    }

                });

            });

            return line.finded;
        });


        //Other Process (adiciona no final)
        other.forEach( line => result.push(line));

        return result;
*/
    }

    action() {

        this.modalshow.onOkuy(this.modalshow, this, null, TModalClick.mcAction, null);

    }

    cormain(line, field) {

        if (!field) return '';

        let lino = (this.modalshow.arrayz ? line[this.modalshow.arrayz][0] : line);
        let array = field.split('#');

        return (array.length <= 1 ? field : lino[array[1]]);

    }

    linevalue(line, field) : string {

        let lino = (this.modalshow.arrayz ? line[this.modalshow.arrayz][0] : line);

        if (       field == 'ProfileTeam') return TProfileTeam[lino[field]].slice(2, 99);
        if (typeof field == 'string')      return lino[field] ? lino[field] : '';

        if (field instanceof Array) {
            let result = '';
            if (lino[field[0]]) {
                result = lino;
                field.forEach(name => result = result[name]);
            }
            return result;
        }

    }

    clickfoto(line) {

        this.modalshow.onOkuy(this.modalshow, this, line, TModalClick.mcFoto, null);

    }

    clickline(line, isItemClick = false) {

        if (isItemClick) return false;

        this.modalshow.onOkuy(this.modalshow, this, line, TModalClick.mcLine, null);

    }

    clickplus(line) {

        this.modalshow.onOkuy(this.modalshow, this, line, TModalClick.mcPlus, null);

    }

    clickicon(line, event) {

        this.modalshow.onOkuy(this.modalshow, this, line, TModalClick.mcPlus, event);

    }

    //DELETE
    //dismiss(line?, anime: boolean = true, onBack: boolean = false) {
    //Nao sei onde estava usando isso...
    dismiss() {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss();
        }

        if (!this.viewCtrl.isOverlay) {
            let objectOpts = (!this.forward ? null : {direction: 'forward'});
            this.navCtrl.pop(objectOpts);
            if (this.modalshow.onBack) this.modalshow.onBack();
        }

        if (!this.pagecut) this.util.statusBarColor(TStatusBar.sbBackupRestore);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/listing-menu/listing-menu.ts